module.exports = __webpack_public_path__ + "img/map-location-pin.77dd3d0d.svg";